const translations = {
  // ─── Navigation / Sidebar ───
  "nav.projekte": { de: "Projekte", en: "Projects", sk: "Projekty" },
  "nav.crm": { de: "CRM", en: "CRM", sk: "CRM" },
  "nav.mitarbeiter": { de: "Mitarbeiter", en: "Employees", sk: "Zamestnanci" },
  "nav.teams": { de: "Teams", en: "Teams", sk: "Tímy" },
  "nav.liveteam": { de: "Live Team", en: "Live Team", sk: "Live tím" },
  "nav.admindashboard": { de: "Admin Dashboard", en: "Admin Dashboard", sk: "Admin Dashboard" },
  "nav.systemhistorie": { de: "System Historie", en: "System History", sk: "System Historia" },
  "nav.einsatzplanung": { de: "Einsatzplanung", en: "Resource Planning", sk: "Plánovanie" },
  "nav.projektzeitenplanung": { de: "Projektzeitenplanung", en: "Project Timeline Planning", sk: "Časový plán projektov" },
  "nav.bauzeitenplan": { de: "Bauzeitenplan", en: "Construction Schedule", sk: "Harmonogram stavby" },
  "nav.terminplaner": { de: "Terminplaner", en: "Scheduler", sk: "Plánovač" },
  "nav.stundenkonten": { de: "Stundenkonten", en: "Timesheets", sk: "Pracovné výkazy" },
  "nav.wochenansicht": { de: "Wochenuebersicht", en: "Weekly Report", sk: "Týždenný prehľad" },
  "nav.monatsansicht": { de: "Monatsuebersicht", en: "Monthly Report", sk: "Mesačný prehľad" },
  "nav.bautagesbericht": { de: "Bautagesbericht", en: "Daily Report", sk: "Denný protokol" },
  "nav.appeinstellungen": { de: "App-Einstellungen", en: "App Settings", sk: "Nastavenia" },
  "nav.integration_nina": { de: "Integration: Nina.ai", en: "Integration: Nina.ai", sk: "Integrácia: Nina.ai" },
  "nav.urlaub": { de: "Urlaub", en: "Vacation", sk: "Dovolenka" },
  "nav.abrechnungen": { de: "Abrechnungen", en: "Billing", sk: "Vyúctovanie" },
  "nav.analytics": { de: "Analytics", en: "Analytics", sk: "Analytika" },
  "nav.gpskarte": { de: "GPS Karte", en: "GPS Map", sk: "GPS Mapa" },
  "nav.gaeb": { de: "GAEB / Kalkulation", en: "GAEB / Calculation", sk: "GAEB / Kalkulácia" },
  "nav.passworttresor": { de: "Passwort-Tresor", en: "Password Vault", sk: "Trezor hesiel" },
  "nav.stempeluhr": { de: "Stempeluhr", en: "Time Clock", sk: "Dochádzka" },
  "nav.tagesuebersicht": { de: "Stundenzettel", en: "Time Sheet", sk: "Pracovný výkaz" },
  "nav.benachrichtigungen": { de: "Benachrichtigungen", en: "Notifications", sk: "Upozornenia" },
  "nav.abmelden": { de: "Abmelden", en: "Logout", sk: "Odhlasiť sa" },

  // ─── Context Navigation (Projekt) ───
  "ctx.aufgaben": { de: "Aufgaben", en: "Tasks", sk: "Ulohy" },
  "ctx.berichte": { de: "Bautagesberichte", en: "Daily Reports", sk: "Denné správy" },
  "ctx.controlling": { de: "Controlling", en: "Controlling", sk: "Controlling" },
  "ctx.plaene": { de: "Pläne", en: "Plans", sk: "Plány" },
  "ctx.einsatzplanung": { de: "Einsatzplanung", en: "Resource Planning", sk: "Plánovanie" },
  "ctx.uebersicht": { de: "Uebersicht", en: "Overview", sk: "Prehľad" },

  // ─── Stempeluhr / Time Clock ───
  "clock.title": { de: "Stempeluhr", en: "Time Clock", sk: "Dochádzka" },
  "clock.einstempeln": { de: "Einstempeln", en: "Clock In", sk: "Príchod" },
  "clock.ausstempeln": { de: "Ausstempeln", en: "Clock Out", sk: "Odchod" },
  "clock.standort": { de: "Standort...", en: "Location...", sk: "Poloha..." },
  "clock.pause_start": { de: "Pause starten", en: "Start Break", sk: "Začať prestávku" },
  "clock.pause_beenden": { de: "Pause beenden", en: "End Break", sk: "Ukončiť prestávku" },
  "clock.in_pause": { de: "In Pause", en: "On Break", sk: "Na prestávke" },
  "clock.eingestempelt_seit": { de: "Eingestempelt seit", en: "Clocked in since", sk: "Príchod od" },
  "clock.nicht_eingestempelt": { de: "Nicht eingestempelt", en: "Not clocked in", sk: "Neprihlásený" },
  "clock.arbeitet": { de: "Arbeitet", en: "Working", sk: "Pracuje" },
  "clock.projekt": { de: "Projekt", en: "Project", sk: "Projekt" },
  "clock.projekt_waehlen": { de: "Projekt wählen", en: "Select project", sk: "Vybrať projekt" },
  "clock.gps_erfasst": { de: "GPS-Standort wird erfasst", en: "GPS location captured", sk: "GPS poloha zachytená" },
  "clock.auto_pause": { de: "Automatische Pause", en: "Automatic break", sk: "Automatická prestávka" },
  "clock.min": { de: "Min.", en: "min.", sk: "min." },
  "clock.heutige_arbeitszeit": { de: "Heutige Arbeitszeit", en: "Today's work time", sk: "Dnešný pracovný čas" },
  "clock.brutto": { de: "Brutto", en: "Gross", sk: "Hrubý" },
  "clock.pause": { de: "Pause", en: "Break", sk: "Prestávka" },
  "clock.netto": { de: "Netto", en: "Net", sk: "Čistý" },
  "clock.auto": { de: "(Auto)", en: "(Auto)", sk: "(Auto)" },
  "clock.letzte_buchungen": { de: "Letzte Buchungen", en: "Recent entries", sk: "Posledné záznamy" },
  "clock.geplante_pause": { de: "Geplante Pause", en: "Planned break", sk: "Plánovaná prestávka" },
  "clock.keine_pause": { de: "Keine Pause", en: "No break", sk: "Bez prestávky" },
  "clock.schnellstart": { de: "Schnellstart", en: "Quick start", sk: "Rýchly štart" },
  "clock.oder": { de: "oder", en: "or", sk: "alebo" },

  // ─── Stundenkonten / Timesheets ───
  "ts.title": { de: "Stundenkonten", en: "Timesheets", sk: "Pracovné výkazy" },
  "ts.kw": { de: "KW", en: "WK", sk: "KT" },
  "ts.tag": { de: "Tag", en: "Day", sk: "Deň" },
  "ts.datum": { de: "Datum", en: "Date", sk: "Dátum" },
  "ts.status": { de: "Status", en: "Status", sk: "Stav" },
  "ts.projekt": { de: "Projekt", en: "Project", sk: "Projekt" },
  "ts.von": { de: "Von", en: "From", sk: "Od" },
  "ts.bis": { de: "Bis", en: "To", sk: "Do" },
  "ts.pause": { de: "Pause", en: "Break", sk: "Prestávka" },
  "ts.az": { de: "AZ", en: "WT", sk: "PČ" },
  "ts.soll": { de: "Soll", en: "Target", sk: "Norma" },
  "ts.ist": { de: "Ist", en: "Actual", sk: "Skutočnosť" },
  "ts.saldo": { de: "Saldo", en: "Balance", sk: "Saldo" },
  "ts.auto_pause_banner": { de: "Automatische Pause", en: "Automatic break", sk: "Automatická prestávka" },
  "ts.ab_stunden": { de: "ab", en: "from", sk: "od" },
  "ts.std_arbeitszeit": { de: "Std. Arbeitszeit", en: "hrs work time", sk: "hod. pracovného času" },
  "ts.mitarbeiter": { de: "Mitarbeiter", en: "Employee", sk: "Zamestnanec" },
  "ts.alle": { de: "Alle", en: "All", sk: "Všetci" },
  "ts.arbeitstag": { de: "Arbeitstag", en: "Workday", sk: "Pracovný deň" },
  "ts.urlaub": { de: "Urlaub", en: "Vacation", sk: "Dovolenka" },
  "ts.krank": { de: "Krank", en: "Sick", sk: "Chorý" },
  "ts.feiertag": { de: "Feiertag", en: "Holiday", sk: "Sviatok" },
  "ts.wochenende": { de: "Wochenende", en: "Weekend", sk: "Víkend" },
  "ts.fahrt_hin": { de: "Fahrt Hin", en: "Travel to", sk: "Cesta tam" },
  "ts.fahrt_rueck": { de: "Fahrt Rück", en: "Travel back", sk: "Cesta späť" },
  "ts.km_hin": { de: "km Hin", en: "km to", sk: "km tam" },
  "ts.km_rueck": { de: "km Rück", en: "km back", sk: "km späť" },

  // ─── Projekte ───
  "proj.title": { de: "Projekte", en: "Projects", sk: "Projekty" },
  "proj.neues_projekt": { de: "Neues Projekt", en: "New Project", sk: "Nový projekt" },
  "proj.name": { de: "Projektname", en: "Project name", sk: "Názov projektu" },
  "proj.status": { de: "Status", en: "Status", sk: "Stav" },
  "proj.typ": { de: "Typ", en: "Type", sk: "Typ" },
  "proj.projektleiter": { de: "Projektleiter", en: "Project Manager", sk: "Projektový manažér" },
  "proj.loeschen": { de: "Projekt löschen", en: "Delete Project", sk: "Odstrániť projekt" },
  "proj.loeschen_confirm": { de: "Soll das Projekt wirklich gelöscht werden?", en: "Do you really want to delete this project?", sk: "Naozaj chcete odstrániť tento projekt?" },
  "proj.loeschen_warnung": { de: "Alle zugehörigen Aufgaben und Zuweisungen werden ebenfalls gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.", en: "All related tasks and assignments will also be deleted. This action cannot be undone.", sk: "Všetky súvisiace úlohy a priradenia budú tiež odstránené. Túto akciu nemožno vrátiť späť." },
  "proj.endgueltig_loeschen": { de: "Endgültig löschen", en: "Permanently delete", sk: "Natrvalo odstrániť" },

  // ─── Mitarbeiter ───
  "emp.title": { de: "Mitarbeiter", en: "Employees", sk: "Zamestnanci" },
  "emp.name": { de: "Name", en: "Name", sk: "Meno" },
  "emp.email": { de: "E-Mail", en: "Email", sk: "E-mail" },
  "emp.rolle": { de: "Rolle", en: "Role", sk: "Rola" },
  "emp.sprache": { de: "Sprache", en: "Language", sk: "Jazyk" },
  "emp.stammdaten": { de: "Stammdaten", en: "Master Data", sk: "Základné údaje" },
  "emp.zugriffsrechte": { de: "Zugriffsrechte", en: "Permissions", sk: "Oprávnenia" },
  "emp.sicherheit": { de: "Sicherheit", en: "Security", sk: "Bezpečnosť" },

  // ─── Sprach-Optionen ───
  "lang.de": { de: "Deutsch", en: "German", sk: "Nemčina" },
  "lang.en": { de: "Englisch", en: "English", sk: "Angličtina" },
  "lang.sk": { de: "Slowakisch", en: "Slovak", sk: "Slovenčina" },

  // ─── Allgemein ───
  "common.speichern": { de: "Speichern", en: "Save", sk: "Uložiť" },
  "common.abbrechen": { de: "Abbrechen", en: "Cancel", sk: "Zrušiť" },
  "common.loeschen": { de: "Löschen", en: "Delete", sk: "Odstrániť" },
  "common.bearbeiten": { de: "Bearbeiten", en: "Edit", sk: "Upraviť" },
  "common.erstellen": { de: "Erstellen", en: "Create", sk: "Vytvoriť" },
  "common.suche": { de: "Suche...", en: "Search...", sk: "Hľadať..." },
  "common.laden": { de: "Laden...", en: "Loading...", sk: "Načítavanie..." },
  "common.keine_daten": { de: "Keine Daten", en: "No data", sk: "Žiadne údaje" },
  "common.ja": { de: "Ja", en: "Yes", sk: "Áno" },
  "common.nein": { de: "Nein", en: "No", sk: "Nie" },
  "common.aktiv": { de: "Aktiv", en: "Active", sk: "Aktívny" },
  "common.inaktiv": { de: "Inaktiv", en: "Inactive", sk: "Neaktívny" },
  "common.alle_verantwortlichen": { de: "Alle Verantwortlichen", en: "All responsible", sk: "Všetci zodpovední" },
  "common.gespeichert": { de: "Gespeichert", en: "Saved", sk: "Uložené" },
  "common.fehler": { de: "Fehler", en: "Error", sk: "Chyba" },

  // ─── CRM ───
  "crm.title": { de: "CRM", en: "CRM", sk: "CRM" },
  "crm.neuer_kunde": { de: "Neuer Kunde", en: "New Customer", sk: "Nový zákazník" },
  "crm.visitenkarte_scannen": { de: "Visitenkarte scannen", en: "Scan business card", sk: "Naskenovať vizitku" },
  "crm.kunde": { de: "Kunde", en: "Customer", sk: "Zákazník" },
  "crm.kontaktart": { de: "Kontaktart", en: "Contact Type", sk: "Typ kontaktu" },
  "crm.verantwortlicher": { de: "Verantwortlicher", en: "Responsible", sk: "Zodpovedný" },

  // ─── Urlaub ───
  "vac.title": { de: "Urlaub", en: "Vacation", sk: "Dovolenka" },
  "vac.antrag": { de: "Urlaubsantrag", en: "Vacation Request", sk: "Žiadosť o dovolenku" },
  "vac.genehmigt": { de: "Genehmigt", en: "Approved", sk: "Schválené" },
  "vac.abgelehnt": { de: "Abgelehnt", en: "Rejected", sk: "Zamietnuté" },
  "vac.ausstehend": { de: "Ausstehend", en: "Pending", sk: "Čakajúce" },
  "vac.genommen": { de: "Genommen", en: "Taken", sk: "Čerpané" },
  "vac.rest": { de: "Rest", en: "Remaining", sk: "Zostatok" },
  "vac.geplant": { de: "Geplant", en: "Planned", sk: "Plánované" },

  // ─── Login ───
  "login.title": { de: "Anmelden", en: "Sign In", sk: "Prihlásiť sa" },
  "login.email": { de: "E-Mail", en: "Email", sk: "E-mail" },
  "login.passwort": { de: "Passwort", en: "Password", sk: "Heslo" },
  "login.anmelden": { de: "Anmelden", en: "Sign In", sk: "Prihlásiť sa" },
  "login.fehler": { de: "Login fehlgeschlagen", en: "Login failed", sk: "Prihlásenie zlyhalo" },

  // ─── Einsatzplanung ───
  "plan.title": { de: "Einsatzplanung", en: "Resource Planning", sk: "Plánovanie zdrojov" },

  // ─── Abrechnungen ───
  "bill.title": { de: "Abrechnungen", en: "Billing", sk: "Vyúčtovanie" },

  // ─── Tagesübersicht ───
  "daily.title": { de: "Tagesübersicht", en: "Daily Overview", sk: "Denný prehľad" },

  // ─── Wochentage ───
  "day.mo": { de: "Mo", en: "Mo", sk: "Po" },
  "day.di": { de: "Di", en: "Tu", sk: "Ut" },
  "day.mi": { de: "Mi", en: "We", sk: "St" },
  "day.do": { de: "Do", en: "Th", sk: "Št" },
  "day.fr": { de: "Fr", en: "Fr", sk: "Pi" },
  "day.sa": { de: "Sa", en: "Sa", sk: "So" },
  "day.so": { de: "So", en: "Su", sk: "Ne" },

  // ─── GPS Einwilligung ───
  "gps.consent_title": { de: "Standorterfassung", en: "Location Tracking", sk: "Sledovanie polohy" },
  "gps.consent_text": { de: "Ihr Standort wird", en: "Your location will be captured", sk: "Vaša poloha bude zaznamenaná" },
  "gps.consent_bold": { de: "nur beim Ein- und Ausstempeln", en: "only when clocking in and out", sk: "iba pri príchode a odchode" },
  "gps.consent_text2": { de: "erfasst - keine dauerhafte Überwachung.", en: "- no permanent monitoring.", sk: "- žiadne trvalé sledovanie." },
  "gps.reason_proof": { de: "Nachweis des Arbeitsorts für die Zeiterfassung", en: "Proof of work location for time tracking", sk: "Dôkaz o mieste výkonu práce" },
  "gps.reason_only_clock": { de: "Erfassung nur beim Ein- und Ausstempeln, nicht dauerhaft", en: "Captured only when clocking in/out, not permanently", sk: "Zaznamenané iba pri príchode/odchode, nie trvalo" },
  "gps.reason_no_tracking": { de: "Keine Überwachung außerhalb der Arbeitszeit", en: "No monitoring outside of working hours", sk: "Žiadne sledovanie mimo pracovného času" },
  "gps.consent_checkbox": { de: "Ich habe verstanden, dass GPS-Daten bei der Zeiterfassung erfasst werden.", en: "I understand that GPS data is captured during time tracking.", sk: "Rozumiem, že GPS údaje sú zaznamenávané počas sledovania času." },
  "gps.decline": { de: "Ohne GPS fortfahren", en: "Continue without GPS", sk: "Pokračovať bez GPS" },
  "gps.accept": { de: "Standort erlauben", en: "Allow location", sk: "Povoliť polohu" },
  "gps.banner_text": { de: "GPS wird während der Zeiterfassung erfasst", en: "GPS is captured during time tracking", sk: "GPS sa zaznamenáva počas sledovania času" },
  "gps.info_title": { de: "GPS-Standorterfassung", en: "GPS Location Tracking", sk: "Sledovanie GPS polohy" },
  "gps.info_what_title": { de: "Was wird erfasst?", en: "What is captured?", sk: "Čo sa zaznamenáva?" },
  "gps.info_what_text": { de: "Beim Ein- und Ausstempeln wird einmalig Ihr GPS-Standort gespeichert.", en: "Your GPS location is saved once when clocking in and out.", sk: "Vaša GPS poloha sa uloží raz pri príchode a odchode." },
  "gps.info_why_title": { de: "Warum?", en: "Why?", sk: "Prečo?" },
  "gps.info_why_text": { de: "Nachweis des Arbeitsortes gemäß Arbeitszeitgesetz und für die korrekte Zuordnung zu Baustellen/Projekten.", en: "Proof of work location according to working time law and for correct assignment to sites/projects.", sk: "Dôkaz o mieste výkonu práce podľa zákona o pracovnom čase a pre správne priradenie k staveniskám/projektom." },
  "gps.info_no_tracking_title": { de: "Keine Dauerüberwachung", en: "No permanent monitoring", sk: "Žiadne trvalé sledovanie" },
  "gps.info_no_tracking_text": { de: "Es findet keine kontinuierliche Standortverfolgung statt. Außerhalb des Ein-/Ausstempelns werden keine Daten erhoben.", en: "There is no continuous location tracking. No data is collected outside of clocking in/out.", sk: "Neprebieha žiadne nepretržité sledovanie polohy. Mimo príchodu/odchodu sa nezbierajú žiadne údaje." },
  "gps.info_storage_title": { de: "Datenspeicherung", en: "Data storage", sk: "Ukladanie údajov" },
  "gps.info_storage_text": { de: "Die GPS-Daten werden zusammen mit Ihrem Zeiteintrag gespeichert und sind nur für Administratoren einsehbar.", en: "GPS data is stored with your time entry and is only visible to administrators.", sk: "GPS údaje sú uložené spolu s vaším časovým záznamom a sú viditeľné iba pre administrátorov." },
  "gps.info_revoke_title": { de: "Widerruf", en: "Revocation", sk: "Odvolanie" },
  "gps.info_revoke_text": { de: "Sie können die GPS-Erfassung jederzeit über Ihren Administrator deaktivieren lassen.", en: "You can have GPS tracking deactivated at any time by your administrator.", sk: "GPS sledovanie si môžete kedykoľvek nechať deaktivovať prostredníctvom vášho administrátora." },
  "gps.info_close": { de: "Verstanden", en: "Understood", sk: "Rozumiem" },
  "gps.consent_date": { de: "GPS-Einwilligung erteilt am", en: "GPS consent given on", sk: "Súhlas s GPS udelený dňa" },
  "gps.no_consent": { de: "Keine GPS-Einwilligung erteilt", en: "No GPS consent given", sk: "Nebol udelený súhlas s GPS" },

  // ─── GPS Audit-Log ───
  "audit.title": { de: "GPS-Einwilligungs-Log", en: "GPS Consent Log", sk: "Záznam súhlasov GPS" },
  "audit.subtitle": { de: "Protokoll aller GPS-Einwilligungen für Compliance-Zwecke", en: "Audit trail of all GPS consents for compliance", sk: "Audit záznam všetkých GPS súhlasov pre compliance" },
  "audit.csv_export": { de: "CSV-Export", en: "CSV Export", sk: "CSV Export" },
  "audit.export_success": { de: "Export erfolgreich", en: "Export successful", sk: "Export úspešný" },
  "audit.total_consents": { de: "Einwilligungen gesamt", en: "Total consents", sk: "Celkové súhlasy" },
  "audit.unique_users": { de: "Mitarbeiter", en: "Employees", sk: "Zamestnanci" },
  "audit.filter": { de: "Filter", en: "Filter", sk: "Filter" },
  "audit.from": { de: "Von", en: "From", sk: "Od" },
  "audit.to": { de: "Bis", en: "To", sk: "Do" },
  "audit.apply_filter": { de: "Filtern", en: "Apply", sk: "Použiť" },
  "audit.reset_filter": { de: "Zurücksetzen", en: "Reset", sk: "Obnoviť" },
  "audit.action": { de: "Aktion", en: "Action", sk: "Akcia" },
  "audit.timestamp": { de: "Zeitpunkt", en: "Timestamp", sk: "Časová pečiatka" },
  "audit.action_given": { de: "Einwilligung erteilt", en: "Consent given", sk: "Súhlas udelený" },
  "audit.action_revoked": { de: "Einwilligung widerrufen", en: "Consent revoked", sk: "Súhlas odvolaný" },
  "audit.no_entries": { de: "Keine Einträge vorhanden", en: "No entries found", sk: "Žiadne záznamy" },
  "audit.entries_shown": { de: "Einträge angezeigt", en: "entries shown", sk: "záznamov zobrazených" },
  "audit.nav_link": { de: "GPS Audit-Log", en: "GPS Audit Log", sk: "GPS Audit Log" },

  // ─── Workspace Mobile ───
  "ws.stempeluhr": { de: "Stempeluhr", en: "Time Clock", sk: "Hodiny" },
  "ws.projekte": { de: "Projekte", en: "Projects", sk: "Projekty" },
  "ws.heute": { de: "Heute", en: "Today", sk: "Dnes" },
  "ws.profil": { de: "Profil", en: "Profile", sk: "Profil" },
  "ws.nicht_eingestempelt": { de: "Nicht eingestempelt", en: "Not clocked in", sk: "Neprihlásený" },
  "ws.eingestempelt_seit": { de: "Eingestempelt seit", en: "Clocked in since", sk: "Prihlásený od" },
  "ws.projekt": { de: "Projekt", en: "Project", sk: "Projekt" },
  "ws.projekt_waehlen": { de: "Projekt auswählen...", en: "Select project...", sk: "Vybrať projekt..." },
  "ws.kein_projekt": { de: "Kein aktives Projekt", en: "No active project", sk: "Žiadny aktívny projekt" },
  "ws.bitte_projekt": { de: "Bitte Projekt auswählen", en: "Please select a project", sk: "Prosím vyberte projekt" },
  "ws.pause": { de: "Pause", en: "Break", sk: "Prestávka" },
  "ws.einstempeln": { de: "Einstempeln", en: "Clock In", sk: "Príchod" },
  "ws.ausstempeln": { de: "Ausstempeln", en: "Clock Out", sk: "Odchod" },
  "ws.keine_projekte": { de: "Keine Projekte", en: "No projects", sk: "Žiadne projekty" },
  "ws.keine_projekte_text": { de: "Dir wurden noch keine Projekte zugewiesen.", en: "No projects assigned to you yet.", sk: "Zatiaľ vám neboli pridelené žiadne projekty." },
  "ws.meine_projekte": { de: "Meine Projekte", en: "My Projects", sk: "Moje projekty" },
  "ws.keine_eintraege": { de: "Heute noch keine Einträge", en: "No entries today", sk: "Dnes žiadne záznamy" },
  "ws.heute_uebersicht": { de: "Heute", en: "Today", sk: "Dnes" },
  "ws.min_pause": { de: "min Pause", en: "min break", sk: "min prestávka" },
  "ws.abmelden": { de: "Abmelden", en: "Log out", sk: "Odhlásiť" },
  "ws.eingestempelt_toast": { de: "Eingestempelt!", en: "Clocked in!", sk: "Prihlásený!" },
  "ws.ausgestempelt_toast": { de: "Ausgestempelt!", en: "Clocked out!", sk: "Odhlásený!" },
  "ws.eingestempelt": { de: "Eingestempelt", en: "Clocked in", sk: "Prihlásený" },
  "ws.seit": { de: "seit", en: "since", sk: "od" },
  "ws.arbeitszeit_brutto": { de: "Arbeitszeit (brutto)", en: "Working time (gross)", sk: "Pracovný čas (hrubý)" },
  "ws.gebuchte_stunden": { de: "Gebuchte Stunden", en: "Booked hours", sk: "Zaknihované hodiny" },
  "ws.aktuell_eingestempelt": { de: "Aktuell eingestempelt", en: "Currently clocked in", sk: "Momentálne prihlásený" },
  "ws.aktiv": { de: "Aktiv", en: "Active", sk: "Aktívny" },
  "ws.abgeschlossen": { de: "Abgeschlossen", en: "Completed", sk: "Dokončený" },
  "ws.beginn": { de: "Beginn", en: "Start", sk: "Začiatok" },
  "ws.ende": { de: "Ende", en: "End", sk: "Koniec" },
  "ws.netto": { de: "Netto", en: "Net", sk: "Čistý" },
  "ws.zeitbuchungen": { de: "Zeitbuchungen", en: "Time entries", sk: "Časové záznamy" },
  "ws.rolle": { de: "Rolle", en: "Role", sk: "Rola" },

  // ─── Mobile Layout ───
  "m.stempeln": { de: "Stempeln", en: "Clock", sk: "Hodiny" },
  "m.einsatz": { de: "Einsatz", en: "Schedule", sk: "Nasadenie" },
  "m.stunden": { de: "Stundenkonto", en: "Time Account", sk: "Konto hodín" },
  "m.tagesuebersicht": { de: "Stundenzettel", en: "Sheet", sk: "Výkaz" },
  "m.projekte": { de: "Projekte", en: "Projects", sk: "Projekty" },
  "m.liveteam": { de: "Live Team", en: "Live Team", sk: "Live Team" },
  "m.admindashboard": { de: "Dashboard", en: "Dashboard", sk: "Dashboard" },
  "m.systemhistorie": { de: "Historie", en: "History", sk: "Historia" },
  "m.abmelden": { de: "Abmelden", en: "Log out", sk: "Odhlásiť" },

  // ─── Mobile Stempeluhr ───
  "m.aktuelle_arbeitszeit": { de: "Aktuelle Arbeitszeit", en: "Current work time", sk: "Aktuálny pracovný čas" },
  "m.projekt": { de: "Projekt", en: "Project", sk: "Projekt" },
  "m.projekt_waehlen": { de: "Projekt auswählen", en: "Select project", sk: "Vybrať projekt" },
  "m.kein_projekt": { de: "Kein aktives Projekt", en: "No active project", sk: "Žiadny aktívny projekt" },
  "m.bitte_projekt": { de: "Bitte Projekt auswählen", en: "Please select a project", sk: "Prosím vyberte projekt" },
  "m.pausenzeit": { de: "Pausenzeit", en: "Break time", sk: "Prestávka" },
  "m.einstempeln": { de: "Einstempeln", en: "Clock In", sk: "Príchod" },
  "m.ausstempeln": { de: "Ausstempeln", en: "Clock Out", sk: "Odchod" },
  "m.auto_pause_info": { de: "{min} min Pause wird automatisch abgezogen", en: "{min} min break deducted automatically", sk: "{min} min prestávka sa automaticky odpočíta" },
  "m.auto_pause_detail": { de: "{min} Min. Pause wird automatisch abgezogen (ab {hours} Std. Arbeitszeit)", en: "{min} min break deducted automatically (from {hours}h working time)", sk: "{min} min prestávka sa automaticky odpočíta (od {hours} hod. pracovného času)" },
  "m.auto_pause_detail_no_min": { de: "{min} Min. Pause wird automatisch abgezogen", en: "{min} min break deducted automatically", sk: "{min} min prestávka sa automaticky odpočíta" },
  "m.keine_auto_pause": { de: "Keine automatische Pause konfiguriert", en: "No automatic break configured", sk: "Žiadna automatická prestávka" },

  // ─── Toast-Nachrichten ───
  "toast.gespeichert": { de: "Gespeichert", en: "Saved", sk: "Uložené" },
  "toast.geloescht": { de: "Gelöscht", en: "Deleted", sk: "Odstránené" },
  "toast.fehler_speichern": { de: "Fehler beim Speichern", en: "Error saving", sk: "Chyba pri ukladaní" },
  "toast.fehler_laden": { de: "Fehler beim Laden", en: "Error loading", sk: "Chyba pri načítavaní" },
  "toast.eingestempelt": { de: "Eingestempelt", en: "Clocked in", sk: "Príchod zaznamenaný" },
  "toast.ausgestempelt": { de: "Ausgestempelt", en: "Clocked out", sk: "Odchod zaznamenaný" },
  "toast.projekt_geloescht": { de: "Projekt gelöscht", en: "Project deleted", sk: "Projekt odstránený" },

  // ─── DayForm (Mobile Tageseingabe) ───
  "df.title": { de: "Tag bearbeiten", en: "Edit day", sk: "Upraviť deň" },
  "df.prev_day": { de: "Vorheriger Tag", en: "Previous day", sk: "Predchádzajúci deň" },
  "df.next_day": { de: "Nächster Tag", en: "Next day", sk: "Nasledujúci deň" },
  "df.edit_only_current_week": { de: "Bearbeitung nur in aktueller Woche möglich", en: "Editing only allowed in the current week", sk: "Úprava možná len v aktuálnom týždni" },
  "df.projects_today": { de: "Projekte heute", en: "Projects today", sk: "Projekty dnes" },
  "df.tap_to_edit": { de: "Tippen zum Bearbeiten", en: "Tap to edit", sk: "Ťuknite na úpravu" },
  "df.add_another_project": { de: "+ Weiteres Projekt", en: "+ Another project", sk: "+ Ďalší projekt" },
  "df.project_locked": { de: "Projekt nicht änderbar — Eintrag löschen + neu anlegen, um Projekt zu wechseln", en: "Project cannot be changed — delete entry + create new to switch", sk: "Projekt nie je možné zmeniť — najskôr vymažte záznam a vytvorte nový" },
  "df.project_auto_applied": { de: "Projekt aus Einsatzplanung übernommen", en: "Project applied from planning", sk: "Projekt prevzatý z plánovania" },
  "df.multi_projects_planned": { de: "Mehrere Projekte für diesen Tag erkannt — bitte wählen", en: "Multiple projects planned — please choose", sk: "Pre tento deň je naplánovaných viacero projektov — vyberte jeden" },
  "df.section_project": { de: "Projekt", en: "Project", sk: "Projekt" },
  "df.section_outbound": { de: "Hinfahrt", en: "Travel out", sk: "Cesta tam" },
  "df.section_work": { de: "Arbeitszeit", en: "Work time", sk: "Pracovný čas" },
  "df.section_return": { de: "Rückfahrt", en: "Travel back", sk: "Cesta späť" },
  "df.section_overnight": { de: "Übernachtung", en: "Overnight stay", sk: "Nocľah" },
  "df.section_note": { de: "Notiz", en: "Note", sk: "Poznámka" },
  "df.field_start": { de: "Start", en: "Start", sk: "Začiatok" },
  "df.field_end": { de: "Ende", en: "End", sk: "Koniec" },
  "df.field_kilometers": { de: "Kilometer", en: "Kilometers", sk: "Kilometre" },
  "df.field_reason": { de: "Grund", en: "Reason", sk: "Dôvod" },
  "df.field_break": { de: "Pause", en: "Break", sk: "Prestávka" },
  "df.break_default_hint": { de: "Standard: {min} Min", en: "Default: {min} min", sk: "Štandard: {min} min" },
  "df.break_none": { de: "Keine", en: "None", sk: "Žiadna" },
  "df.accommodation_placeholder": { de: "Unterkunft (z.B. Hotel ABC)", en: "Accommodation (e.g. Hotel ABC)", sk: "Ubytovanie (napr. Hotel ABC)" },
  "df.note_placeholder": { de: "Optionale Notiz zum Tag…", en: "Optional note for the day…", sk: "Voliteľná poznámka k dňu…" },
  "df.accommodation_label": { de: "Unterkunft", en: "Accommodation", sk: "Ubytovanie" },
  "df.accommodation_active": { de: "Aktiv", en: "Active", sk: "Aktívne" },
  "df.accommodation_apply": { de: "Übernehmen", en: "Apply", sk: "Prevziať" },
  "df.summary_title": { de: "Übersicht", en: "Summary", sk: "Prehľad" },
  "df.summary_work": { de: "Arbeit", en: "Work", sk: "Práca" },
  "df.summary_travel": { de: "Fahrt", en: "Travel", sk: "Jazda" },
  "df.summary_meal_allowance": { de: "VMA", en: "Meal", sk: "Stravné" },
  "df.select_project": { de: "Projekt wählen", en: "Choose project", sk: "Vyberte projekt" },
  "df.loading_projects": { de: "Projekte werden geladen…", en: "Loading projects…", sk: "Načítavajú sa projekty…" },
  "df.no_projects_assigned": { de: "Keine Projekte zugewiesen. Bitte Admin kontaktieren.", en: "No projects assigned. Please contact admin.", sk: "Nemáte priradené projekty. Kontaktujte administrátora." },
  "df.no_match": { de: "Keine Treffer", en: "No matches", sk: "Žiadne výsledky" },
  "df.planned_today": { de: "Geplant", en: "Planned", sk: "Plánované" },
  "df.btn_save": { de: "Speichern", en: "Save", sk: "Uložiť" },
  "df.btn_update": { de: "Aktualisieren", en: "Update", sk: "Aktualizovať" },
  "df.delete_confirm": { de: "„{name}\" für diesen Tag wirklich löschen?", en: "Really delete „{name}\" for this day?", sk: "Naozaj vymazať „{name}\" pre tento deň?" },
  "df.toast_saved": { de: "Tag gespeichert", en: "Day saved", sk: "Deň uložený" },
  "df.toast_deleted": { de: "Eintrag gelöscht", en: "Entry deleted", sk: "Záznam vymazaný" },
  "df.toast_error_save": { de: "Netzwerkfehler beim Speichern", en: "Network error while saving", sk: "Chyba siete pri ukladaní" },
  "df.toast_error_delete": { de: "Fehler beim Löschen", en: "Error while deleting", sk: "Chyba pri mazaní" },
  "df.toast_select_project": { de: "Bitte Projekt wählen", en: "Please choose a project", sk: "Vyberte prosím projekt" },
  "df.toast_min_times": { de: "Mindestens Arbeits- oder Hinfahrt-Zeiten eingeben", en: "Enter at least work or outbound times", sk: "Zadajte aspoň pracovný čas alebo cestu tam" },
  "df.no_workday": { de: "Kein Arbeitstag — keine Erfassung erforderlich", en: "Not a workday — no entry required", sk: "Nie je pracovný deň — záznam nie je potrebný" },
  "df.abs_urlaub": { de: "Urlaub", en: "Vacation", sk: "Dovolenka" },
  "df.abs_krank": { de: "Krank", en: "Sick", sk: "PN" },
  "df.abs_feiertag": { de: "Feiertag", en: "Holiday", sk: "Sviatok" },
  "df.abs_frei": { de: "Frei", en: "Off", sk: "Voľno" },
  "df.reason_out_baustelle": { de: "Fahrt zur Baustelle", en: "Trip to site", sk: "Cesta na stavbu" },
  "df.reason_out_hotel": { de: "Fahrt vom Hotel zur Baustelle", en: "From hotel to site", sk: "Cesta z hotela na stavbu" },
  "df.reason_out_material": { de: "Materialbeschaffung", en: "Material pickup", sk: "Nákup materiálu" },
  "df.reason_out_other": { de: "Sonstiges", en: "Other", sk: "Iné" },
  "df.reason_back_home": { de: "Rückfahrt nach Hause", en: "Trip home", sk: "Cesta domov" },
  "df.reason_back_hotel": { de: "Rückfahrt ins Hotel", en: "Back to hotel", sk: "Cesta späť do hotela" },
  "df.reason_back_material": { de: "Materialbeschaffung", en: "Material pickup", sk: "Nákup materiálu" },
  "df.reason_back_other": { de: "Sonstiges", en: "Other", sk: "Iné" },
  "df.reason_placeholder": { de: "z.B. Fahrt zur Baustelle", en: "e.g. Trip to site", sk: "napr. Cesta na stavbu" },

  // ─── Mobile Stundenkonto / Eingabe Übersichtskarte ───
  "msk.heute": { de: "Heute", en: "Today", sk: "Dnes" },
  "msk.gearbeitet": { de: "Gearbeitet", en: "Worked", sk: "Odpracované" },
  "msk.soll": { de: "Soll", en: "Target", sk: "Plán" },
  "msk.differenz": { de: "Differenz", en: "Difference", sk: "Rozdiel" },
  "msk.im_plan": { de: "Im Plan", en: "On target", sk: "Podľa plánu" },
  "msk.kein_soll": { de: "Kein Soll", en: "No target", sk: "Bez plánu" },
  "msk.leicht_drunter": { de: "Leicht drunter", en: "Slightly under", sk: "Mierne pod plánom" },
  "msk.hinterher": { de: "Hinterher", en: "Behind", sk: "V sklze" },
  "msk.no_data": { de: "Keine Daten verfügbar", en: "No data available", sk: "Žiadne dáta" },
  "msk.synced": { de: "Synchronisiert", en: "Synced", sk: "Synchronizované" },
  "msk_o.week": { de: "Diese Woche", en: "This week", sk: "Tento týždeň" },
  "msk_o.month": { de: "Monat", en: "Month", sk: "Mesiac" },
  "msk_o.gesamt": { de: "Gesamt", en: "Total", sk: "Spolu" },
  "msk_o.prev_month": { de: "Vorheriger Monat", en: "Previous month", sk: "Predchádzajúci mesiac" },
  "msk_o.next_month": { de: "Nächster Monat", en: "Next month", sk: "Nasledujúci mesiac" },
  "msk_o.workdays": { de: "Arbeitstage", en: "Workdays", sk: "Pracovné dni" },
  "msk_o.holidays": { de: "Feiertage", en: "Holidays", sk: "Sviatky" },
  "msk_o.travel_time": { de: "Fahrzeit", en: "Travel time", sk: "Čas jazdy" },
  "msk_o.kilometers": { de: "Kilometer", en: "Kilometers", sk: "Kilometre" },
  "msk_o.projects": { de: "Projekte", en: "Projects", sk: "Projekty" },
  "msk_o.active": { de: "aktiv", en: "active", sk: "aktívnych" },
  "msk_o.no_project_entries": { de: "Keine Projekteinträge in diesem Monat", en: "No project entries this month", sk: "Žiadne záznamy projektov v tomto mesiaci" },

  // ─── Sprach-Switcher ───
  "lang.title": { de: "Sprache", en: "Language", sk: "Jazyk" },
  "lang.de": { de: "Deutsch", en: "German", sk: "Nemčina" },
  "lang.en": { de: "Englisch", en: "English", sk: "Angličtina" },
  "lang.sk": { de: "Slowakisch", en: "Slovak", sk: "Slovenčina" },

  // ─── Common UI ───
  "common.more": { de: "Mehr", en: "More", sk: "Viac" },
  "common.cancel": { de: "Abbrechen", en: "Cancel", sk: "Zrušiť" },
  "common.search": { de: "Suchen…", en: "Search…", sk: "Hľadať…" },
  "common.delete": { de: "Löschen", en: "Delete", sk: "Vymazať" },
  "common.save": { de: "Speichern", en: "Save", sk: "Uložiť" },
  "common.close": { de: "Schließen", en: "Close", sk: "Zavrieť" },
  "common.loading": { de: "Lädt…", en: "Loading…", sk: "Načítava sa…" },

  // ─── Greeting (zeitabhängig) ───
  "greeting.good_morning": { de: "Guten Morgen", en: "Good morning", sk: "Dobré ráno" },
  "greeting.good_day": { de: "Hallo", en: "Hello", sk: "Dobrý deň" },
  "greeting.good_evening": { de: "Guten Abend", en: "Good evening", sk: "Dobrý večer" },

  // ─── Mobile Nav (Bottom + More) ───
  "m.meine_aufgaben": { de: "Meine Aufgaben", en: "My Tasks", sk: "Moje úlohy" },
  "m.doc_scanner": { de: "Dokument scannen", en: "Scan document", sk: "Skenovať dokument" },

  // ─── Mobile Projektliste ───
  "mp.title": { de: "Meine Projekte", en: "My Projects", sk: "Moje projekty" },
  "mp.active": { de: "{count} aktiv", en: "{count} active", sk: "{count} aktívnych" },
  "mp.search": { de: "Projekt suchen…", en: "Search project…", sk: "Hľadať projekt…" },
  "mp.filter_all": { de: "Alle", en: "All", sk: "Všetky" },
  "mp.filter_today": { de: "Heute", en: "Today", sk: "Dnes" },
  "mp.filter_week": { de: "Woche", en: "Week", sk: "Týždeň" },
  "mp.filter_mine": { de: "Meine", en: "Mine", sk: "Moje" },
  "mp.filter_open": { de: "Offen", en: "Open", sk: "Otvorené" },
  "mp.assigned_today": { de: "Heute eingeplant", en: "Scheduled today", sk: "Dnes naplánované" },
  "mp.assigned_tomorrow": { de: "Morgen eingeplant", en: "Scheduled tomorrow", sk: "Zajtra naplánované" },
  "mp.open_tasks": { de: "{count} offene Aufgaben", en: "{count} open tasks", sk: "{count} otvorených úloh" },
  "mp.no_projects": { de: "Keine Projekte", en: "No projects", sk: "Žiadne projekty" },
  "mp.show_info": { de: "Projekt-Info anzeigen", en: "Show project info", sk: "Zobraziť info o projekte" },
  "mp.fav_add": { de: "Als Favorit markieren", en: "Mark as favorite", sk: "Označiť ako obľúbený" },
  "mp.fav_remove": { de: "Favorit entfernen", en: "Remove favorite", sk: "Odstrániť z obľúbených" },
  "mp.soon": { de: "BALD", en: "SOON", sk: "ČOSKORO" },
  "mp.tab_info": { de: "Info", en: "Info", sk: "Info" },
  "mp.tab_tasks": { de: "Aufgaben", en: "Tasks", sk: "Úlohy" },
  "mp.tab_reports": { de: "Berichte", en: "Reports", sk: "Správy" },

  // ─── Mobile Tasks ───
  "mt.new_task": { de: "Neue Aufgabe", en: "New task", sk: "Nová úloha" },
  "mt.add_btn": { de: "Aufgabe", en: "Task", sk: "Úloha" },
  "mt.quick_task": { de: "Schnell-Aufgabe", en: "Quick task", sk: "Rýchla úloha" },
  "mt.quick_mode": { de: "Schnellmodus", en: "Quick mode", sk: "Rýchly režim" },
  "mt.single_mode": { de: "Einzeln", en: "Single", sk: "Jednotlivá" },
  "mt.create_button": { de: "Aufgabe erstellen", en: "Create task", sk: "Vytvoriť úlohu" },
  "mt.title": { de: "Titel", en: "Title", sk: "Názov" },
  "mt.description": { de: "Beschreibung", en: "Description", sk: "Popis" },
  "mt.area": { de: "Bereich / Ort im Projekt (optional)", en: "Area / Location in project (optional)", sk: "Oblasť / Miesto v projekte (voliteľné)" },
  "mt.plan_marker": { de: "Standort auf Plan (optional)", en: "Plan marker (optional)", sk: "Pozícia na pláne (voliteľné)" },
  "mt.assign": { de: "Zuweisen an (Mehrfach möglich)", en: "Assign to (multiple)", sk: "Priradiť (viacerým možné)" },
  "mt.title_placeholder": { de: "z.B. Aussenleuchte montieren", en: "e.g. Install outdoor lamp", sk: "napr. Inštalovať vonkajšie svietidlo" },
  "mt.filter_all": { de: "Alle", en: "All", sk: "Všetky" },
  "mt.filter_mine": { de: "Meine", en: "Mine", sk: "Moje" },
  "mt.filter_open": { de: "Offen", en: "Open", sk: "Otvorené" },
  "mt.filter_in_progress": { de: "In Arbeit", en: "In progress", sk: "V práci" },
  "mt.filter_done": { de: "Erledigt", en: "Done", sk: "Hotové" },
  "mt.status_offen": { de: "Offen", en: "Open", sk: "Otvorené" },
  "mt.status_in_arbeit": { de: "In Arbeit", en: "In progress", sk: "V práci" },
  "mt.status_erledigt": { de: "Erledigt", en: "Done", sk: "Hotové" },
  "mt.not_assigned": { de: "Nicht zugewiesen", en: "Not assigned", sk: "Nepriradené" },
  "mt.progress": { de: "Fortschritt", en: "Progress", sk: "Postup" },
  "mt.no_tasks": { de: "Noch keine Aufgaben", en: "No tasks yet", sk: "Zatiaľ žiadne úlohy" },
  "mt.no_match_filter": { de: "Keine mit diesem Filter", en: "None match this filter", sk: "Žiadne s týmto filtrom" },
  "mt.photo_upload": { de: "Foto wird hochgeladen...", en: "Uploading photo...", sk: "Nahráva sa foto..." },
  "mt.photo_required": { de: "Foto-Pflicht: Mindestens ein Foto erforderlich", en: "Photo required", sk: "Povinné foto" },
  "mt.recording": { de: "Aufnahme läuft... Tippe zum Stoppen", en: "Recording... Tap to stop", sk: "Nahráva sa... Ťuknite pre zastavenie" },
  "mt.transcribing": { de: "Wird transkribiert...", en: "Transcribing...", sk: "Prepisuje sa..." },

  // ─── Mobile Stundenkonto (Übersicht) ───
  "msk_o.title": { de: "Stundenkonto", en: "Hour account", sk: "Konto hodín" },
  "msk_o.week": { de: "Woche", en: "Week", sk: "Týždeň" },
  "msk_o.month": { de: "Monat", en: "Month", sk: "Mesiac" },
  "msk_o.target": { de: "Soll", en: "Target", sk: "Plán" },
  "msk_o.actual": { de: "Ist", en: "Actual", sk: "Stav" },
  "msk_o.diff": { de: "Differenz", en: "Difference", sk: "Rozdiel" },
  "msk_o.no_data": { de: "Keine Daten verfügbar", en: "No data available", sk: "Žiadne dáta" },
  "msk_o.synced": { de: "Synchronisiert", en: "Synced", sk: "Synchronizované" },
  "msk_o.project_breakdown": { de: "Aufschlüsselung nach Projekt", en: "By project", sk: "Podľa projektu" },
  "msk_o.absence_urlaub": { de: "Urlaub", en: "Vacation", sk: "Dovolenka" },
  "msk_o.absence_krank": { de: "Krank", en: "Sick", sk: "PN" },
  "msk_o.absence_feiertag": { de: "Feiertag", en: "Holiday", sk: "Sviatok" },
  "msk_o.absence_frei": { de: "Frei", en: "Off", sk: "Voľno" },
};

export default translations;
